import { ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core';
import { HttpStateService } from '../../core/services/backend/httpstate.service';
import { HttpProgressState } from '../../core/services/base/base.service';
import { DxProgressBarModule } from 'devextreme-angular/ui/progress-bar';
import { LayoutService } from '~/app/core/services/store/layout.service';

@Component({
  selector: 'app-loading-bar',
  template: `
    <dx-progress-bar
      [value]="false"
      width="100%"
      [class.d-none]="!this.loading"
    ></dx-progress-bar>
  `,
  imports: [DxProgressBarModule],
})
export class LoadingBarComponent implements OnInit {
  public loading = false;
  @Input() public filterBy: string | null = null;

  private httpStateService = inject(HttpStateService);
  private layoutService = inject(LayoutService);
  private cdRef = inject(ChangeDetectorRef);

  /**
   * receives all HTTP requests and filters them by the filterBy
   * values provided
   */
  public ngOnInit() {
    this.httpStateService.state.subscribe((progress) => {
      if (progress && progress.url) {
        if (!this.filterBy) {
          this.loading = progress.state === HttpProgressState.start;
        } else if (progress.url.indexOf(this.filterBy) !== -1) {
          this.loading = progress.state === HttpProgressState.start;
        }
        this.layoutService.appInLoadingStateSubject.next(this.loading);
        this.cdRef.detectChanges();
      }
    });
  }
}
